module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "子数据列表",
      "visible": _vm.$store.state.cart.carDialogVisible,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.$store.state.cart, "carDialogVisible", $event)
      }
    }
  }, [_c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.$store.state.cart.ChildProductInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "new_productno",
      "label": "物料编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_product_name",
      "label": "物料描述",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_uom_name",
      "label": "单位",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.packageunit[0].Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_qty",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_price_typeName",
      "label": "价格类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(row) {
        return [_vm._v("\n            " + _vm._s((row.standard_price_show || 0).toFixed(2)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优惠价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(row) {
        return [_vm._v("\n            " + _vm._s((row.new_price_show || 0).toFixed(2)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小计"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(row) {
        return [_vm._v("\n            " + _vm._s((row.rowTotalPrice || 0).toFixed(2)) + "\n          ")]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('router-view', {
    staticStyle: {
      "height": "100%"
    },
    style: ({
      background: this.$store.state.pageBackground
    })
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6f687f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 847
// module chunks = 99